<template>
  <div class="col-12" style="padding: 0px">
    <div class="card">
        <div class="card-header">
            <h5>
                <i class="fa fa-table"></i>
                ادارة الجداول <button class="btn btn-sm btn-primary" style="padding: 5px; border-radius: 0px" v-b-modal.create>
                    <i class="fa fa-plus"></i>
                     اضافة جدول
                </button>
            </h5>
            <b-modal id="create" title="اضافة" hide-footer>
                <div class="form-group">
                    <h5 for="">اسم الجدول</h5>
                    <input type="text"
                    class="form-control" v-model="create.title" aria-describedby="helpId" placeholder="اكتب هنا...">
                </div>
                <div class="form-group">
                  <label for="">توقيت الحصص</label>
                  <select class="form-control" v-model="create.time_id">
                    <option v-for="t in times" :key="t._id" :value="t._id">{{ t.title }}</option>
                  </select>
                </div>
                <div class="col-12 text-center g">
                    <button class="btn btn-primary" @click="add()">
                        <i class=" fa fa-check"></i>
                        اضافة الجدول 
                    </button>
                </div>
            </b-modal>
        </div>
        <div class="card-body">
            <div class="col-12 table-responsive" style="padding: 0px">
                <table class="table table-sm table-bordered table-hover table-striped">
                    <thead>
                        <th>
                            العنوان
                        </th>
                        <th>
                            توقيت الحصص
                        </th>
                        <th>
                            آخر تعديل
                        </th>
                        <th>
                            خيارات
                        </th>
                    </thead>
                    <tbody>
                        <tr v-for="table in tables" :key="table._id">
                            <td>
                                {{ table.title }}
                            </td>
                            <td>
                                {{ table.time_title }}
                            </td>
                            <td>
                                {{ table.last_edit }}
                            </td>
                            <td>
                                <button @click="$router.push(`/tables/table/${table._id}`)" class="btn btn-sm btn-primary" style="padding: 5px; border-radius: 0px">
                                    <i class="fa fa-edit"></i>
                                    ادارة جدول
                                </button>
                                <button class="btn btn-sm btn-danger" style="padding: 5px; border-radius: 0px">
                                    <i class="fa fa-trash"></i>
                                    حذف
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import Ripple from "vue-ripple-directive";
function makeid(length) {
    let result = '';
    const characters = 'abcdefghkmnoprstuvwxyz123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
}
import { VBModal, BModal, BFormInput, BDropdown, BDropdownItem } from "bootstrap-vue";
export default {
    components: {
        // Layouts
        BDropdown, BDropdownItem,
        BModal,BFormInput},
    directives: {
        Ripple,
        "b-modal": VBModal,
    },
    data(){
        return {
            user: JSON.parse(localStorage.getItem("user")),
            tables: [],
            create: {},
            times: []
        }
    },
    created(){
        var g = this;
        g.getTables()
        $.post(api + '/user/times/list', {
            jwt: g.user.jwt
        }).then(function(r){
            if(r.status != 100){
                alert(r.response, 200)
            }else{
                g.times = r.response;
                g.create.time_id = g.times[0]?._id
            }
        }).fail(function(){
            alert('حدث خطأ في الاتصال', 200)
        })
    },
    methods: {
        add(){
            var g = this;
            if(!g.create.title || g.create.title == ""){
                return alert("برجاء كتابة اسم الجدول", 200);
            }
            if(!g.create.time_id || g.create.time_id== ""){
                return alert("برجاء اختيار توقيت الحصص", 200);
            }
            $.post(api + '/user/tables/create', {
                jwt: g.user.jwt,
                title: g.create.title,
                time_id: g.create.time_id
            }).then(function(r){
                if(r.status != 100){
                    alert(r.response, 200)
                }else{
                    g.getTables()
                    $("#create___BV_modal_header_ > button").click()
                }
            }).fail(function(){
                alert('حدث خطأ في الاتصال', 200)
            })
        },
        getTables(){
            var g = this;
            $.post(api + '/user/tables/list', {
                jwt: g.user.jwt
            }).then(function(r){
                if(r.status != 100){
                    alert(r.response, 200)
                }else{
                    g.tables = r.response;
                }
            }).fail(function(){
                alert('حدث خطأ في الاتصال', 200)
            })
        }
    }
}
</script>

<style>

</style>